var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.5L16.5 8.25M11.9166 18.3333H19.25M4.58329 14.6667L3.66663 18.3333L7.33329 17.4167L17.9538 6.79617C18.2975 6.45237 18.4906 5.98613 18.4906 5.5C18.4906 5.01387 18.2975 4.54763 17.9538 4.20383L17.7961 4.04617C17.4523 3.70247 16.9861 3.50939 16.5 3.50939C16.0138 3.50939 15.5476 3.70247 15.2038 4.04617L4.58329 14.6667Z",
    stroke: "#112051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.0ebbc840e4304d4ea2920d2ac8080679.svg";
export { ForwardRef as ReactComponent };